import { z } from "zod";

export default {
  params: z.object({
    message: z.string().trim().min(1).max(5000),
    path: z.string().startsWith("/").max(2000),
  }),
  response: z.void(),
};
